var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGiftSmall = function SvgGiftSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.077 20.59H5.82c-.769 0-1.393-.624-1.393-1.394v-8.54H22.47v8.54c0 .77-.624 1.393-1.393 1.393Z",
    fill: "#2955DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.928 10.656H11.97v9.933h2.958v-9.933Z",
    fill: "#FFD522"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.634 10.648v8.54c0 .77-.624 1.394-1.393 1.394h.835c.77 0 1.393-.624 1.393-1.393v-8.54h-.835Z",
    fill: "#999",
    opacity: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.929 17.226a.202.202 0 0 1-.202-.202v-5.697a.202.202 0 0 1 .404 0v5.697c0 .112-.09.202-.202.202ZM14.929 20.25a.202.202 0 0 1-.202-.203V18.07a.202.202 0 0 1 .404 0v1.979c0 .111-.09.202-.202.202Z",
    fill: "#0A379A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.26 7.287 4.571 7.25a.677.677 0 0 0-.678.676l-.005 2.106c0 .374.302.678.676.679l17.687.035a.677.677 0 0 0 .679-.676l.004-2.106a.677.677 0 0 0-.676-.678Z",
    fill: "#2955DE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m22.931 10.086.004-2.105a.677.677 0 0 0-.676-.679l-.843-.001c.374 0 .676.304.676.678l-.005 2.105a.677.677 0 0 1-.678.676l.844.002a.677.677 0 0 0 .678-.676Z",
    fill: "#999",
    opacity: 0.7
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m15.339 7.289-3.846-.008-.007 3.46 3.846.008.007-3.46Z",
    fill: "#FFC737"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m12.44 7.274 2.02-3.481c.897-1.548 3.134-1.543 4.024.008.891 1.55-.23 3.484-2.019 3.48l-4.024-.007Z",
    fill: "#FFD522"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m16.097 7.29.368.002c1.788.003 2.91-1.93 2.019-3.482a2.308 2.308 0 0 0-.77-.808c.181.162.342.357.474.586.89 1.55-.303 3.706-2.092 3.703",
    fill: "#999",
    opacity: 0.7
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m14.39 7.267-2.005-3.49c-.89-1.55-3.127-1.555-4.024-.007-.898 1.548.216 3.486 2.005 3.49l4.025.007Z",
    fill: "#FFD522"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.663 5.82a.205.205 0 0 1-.1.009c-.718-.113-1.691.618-1.701.626a.201.201 0 0 1-.239.005.204.204 0 0 1-.077-.226c.02-.065.513-1.595 2.19-1.985a.202.202 0 0 1 .09.394 2.603 2.603 0 0 0-1.586 1.106c.394-.202.916-.393 1.385-.32a.202.202 0 0 1 .037.39ZM12.265 6.832l-.006.002a.202.202 0 0 1-.255-.129c-.018-.055-.47-1.369-1.92-1.683a.203.203 0 0 1 .085-.395c1.68.364 2.198 1.887 2.219 1.951a.202.202 0 0 1-.123.253Z",
    fill: "#0A379A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.303 7.276a1.194 1.194 0 1 0 .005-2.388l-1.775-.003a1.194 1.194 0 1 0-.005 2.388l1.775.003Z",
    fill: "#2955DE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.933 7.272a1.272 1.272 0 0 0 1.27-1.266c.002-.457-.242-.86-.607-1.084.518.13.904.602.903 1.16a1.197 1.197 0 0 1-1.196 1.192",
    fill: "#999",
    opacity: 0.7
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.415 10.913a.214.214 0 0 1-.07.012l-4.01-.008a.201.201 0 1 1 .002-.404l4.01.008a.202.202 0 0 1 .068.392ZM21.035 10.939a.214.214 0 0 1-.07.012l-5.137-.01a.201.201 0 1 1 .002-.404l5.137.01a.202.202 0 0 1 .068.392Z",
    fill: "#0A379A"
  })));
};
export default SvgGiftSmall;